import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../features/slices/lockScreenSlice";
import Cookies from "js-cookie";
import { withHooks } from "../hooks/withHooks";
import {
  useLockScreenSelector,
  useRootSelector,
} from "../hooks/useAppSelector";

class InactivityLock extends Component {
  setupChecking = () => {
    const { lockScreen, locked, isLogged } = this.props;
    const inactivityLockTime = parseInt(
      Cookies.get("UserInactivityLockTime"),
      10
    );

    if (inactivityLockTime > -1 && !locked && isLogged) {
      this.interval = setInterval(() => {
        const lastActivity = parseInt(Cookies.get("LastActivity"), 10);
        const inactivityTimeInS = (new Date().getTime() - lastActivity) / 1000;

        if (inactivityTimeInS > inactivityLockTime) {
          lockScreen();
        }
      }, 1000);
    } else {
      if (this.interval) clearInterval(this.interval);
    }
  };

  componentDidUpdate() {
    if (this.interval) clearInterval(this.interval);
    this.setupChecking();
  }

  render = () => null;
}

function mapDispatchToProps(dispatch) {
  return {
    lockScreen: bindActionCreators(Actions.lockScreen, dispatch),
  };
}

const InactivityLockContainer = withHooks(
  connect(null, mapDispatchToProps)(InactivityLock),
  useRootSelector,
  useLockScreenSelector
);

export default InactivityLockContainer;
